import { Action } from '../action';
import { AppState } from './state';
import { AppType } from './action';
import { AuthType } from '../Auth/action';
import { v4 as uuidv4 } from 'uuid';

export const initialState: AppState = {
    loading: true,
    sidebarOpened: true,
    lastResponseCode: 200,
    userId: uuidv4(),
};

export const appReducer = (state: AppState | undefined, action: Action): AppState => {
    state = state ?? initialState;

    switch (action.type) {
        case AppType.FinishedLoading:
            return { ...state, loading: false };
        case AppType.ToggledSidebar:
            return { ...state, sidebarOpened: !state.sidebarOpened };
        case AppType.ApiReturnedResponseCode:
            return { ...state, lastResponseCode: action.code, lastResponseMessage: action.message };
        case AuthType.TokenExpired:
            return initialState;
        default:
            return state;
    }
};
